export enum PalletTypes {
	All = "All",
	Generic = "Generic",
	European = "European",
	SemiEuropean = "SemiEuropean",
	American = "American",
	HL = "HL",
	Other = "Other",
	None = "None"
}